<template>
  <div class="simple-search-result-row">
    <div class="simple-search-result-row-image simpleImg">
      <img v-show="imageLoaded" @load="imageLoaded = true" :src="mediaUrl" />
      <spinner v-show="!imageLoaded" />
    </div>
    <div class="simple-search-result-row-text pl-1 py-1">
      <div class="simple-search-result-row-text-number">
        <highlight class="cutText" :input="articleNo" :searchPhrases="searchPhrases" data-cy="search-article-articleno-txt" />
      </div>
      <div class="simple-search-result-row-text-description simpleName">
        <highlight class="cutText" :input="Name" :searchPhrases="searchPhrases" data-cy="search-article-name-txt" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import highlight from "@common/components/TextHighlighter.vue";
import spinner from "@common/components/Spinner.vue";
export default {
  data() {
    return { imageLoaded: false };
  },
  components: {
    highlight, //Sub component for highlight search results
    spinner
  },
  props: ["articleId", "articleNo", "Name", "Description", "searchPhrases", "language"],
  computed: {
    ...mapState(["meta", "auth"]),
    mediaUrl() {
      return (
        this.meta.config.apiUrl +
        "/api/webclient/mediaasset/GetArticlePreviewImage?articleId=" +
        this.articleId +
        "&language=" +
        this.language +
        "&width=80&height=80&key=" +
        this.auth.token
      );
    }
  },
  watch: {
    mediaUrl() {
      this.imageLoaded = false;
    }
  }
};
</script>
